import { ReactNode } from "react";
import { useAlimentacaoPermissao } from "@/shared/hooks/useAlimentacaoPermissao";
import { Card, CardContent } from "@/shared/components/ui/card";
import { Loader2, Lock } from "lucide-react";

interface AlimentacaoGuardProps {
  children: ReactNode;
  scope: "alimentar_geral" | "alimentar_modulo";
  module?: string;
}

/**
 * Protege rotas de alimentação de bases IA.
 * Admin ou quem tem permissão em ai_alimentacao_permissoes pode acessar.
 */
const AlimentacaoGuard = ({ children, scope, module }: AlimentacaoGuardProps) => {
  const { podeAlimentar, isLoading } = useAlimentacaoPermissao(scope, module);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-24">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!podeAlimentar) {
    return (
      <div className="space-y-6 p-6">
        <Card className="border-amber-500/50 bg-amber-500/5">
          <CardContent className="flex flex-col items-center justify-center py-16 gap-4">
            <Lock className="h-12 w-12 text-amber-600" />
            <h2 className="text-lg font-semibold">Sem permissão</h2>
            <p className="text-sm text-muted-foreground text-center max-w-md">
              Você não tem permissão para alimentar esta base. Entre em contato com o administrador para solicitar acesso em Sistema → Permissões de Alimentação.
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <>{children}</>;
};

export default AlimentacaoGuard;
